export default {
  "memberDeposits.title": "会员存款",
  "memberDeposits.thead.index": "#序号",
  "memberDeposits.thead.merOrderno": "存款单号",
  "memberDeposits.thead.orderno": "第三方存款单号",
  "memberDeposits.thead.userno": "会员ID",
  "memberDeposits.thead.amount": "存款金额",
  "memberDeposits.thead.platform": "存款方式",
  "memberDeposits.thead.deviceType": "终端类型",
  "memberDeposits.thead.depositStatus": "存款状态",
  "memberDeposits.thead.depositTime": "存款时间",
  "memberDeposits.thead.completeTime": "完成时间",
  "memberDeposits.thead.createTime": "存款时间",
  "memberDeposits.thead.action": "操作",
  "memberDeposits.copy.success": "复制成功!",
  "memberDeposits.tooltip.copy.orderNo": "复制订单号: {text}",
  "memberDeposits.tooltip.copy.merOrderNo": "复制商户订单号: {text}",
  "memberDeposits.tooltip.copy.userNo": "复制会员ID: {text}",
  "memberDeposits.action.detail": "详情",
  "memberDeposits.search.waitPay": "待支付",
  "memberDeposits.search.paying": "支付中",
  "memberDeposits.search.paySuccess": "支付成功",
  "memberDeposits.search.payFail": "支付失败",
  "memberDeposits.search.cancel": "取消",

};